export default __webpack_public_path__ + "static/illustration-man-sign-combined-f84bb15bf6a0bd4a34837f8b41bfdba6.svg";